<!--eslint-disable-->
<template>
<div class="view">
    <CadastroEmpresasForm :formCadastroVisible="formCadastroVisible" :company="company" v-on:closeDialog="closeCadastroDialog"></CadastroEmpresasForm>
    <FilesDialog :filesDialogVisible="filesDialogVisible" :urls="urls" v-on:closeDialog="closeFilesDialog"></FilesDialog>
    <el-row>
        
        <el-button class="button-cadastro" type="primary" @click="addCompany" size="medium" circle><i class="el-icon-plus"></i></el-button>
        
        <!--<el-popover placement="left" trigger="click" width="100">-->
        <el-popover placement="left" trigger="hover" width="100">
            <!-- <el-checkbox v-model="checkAll" @change="showAllColumns" label="Selecionar Todos"></el-checkbox>
            <hr> -->
            <el-checkbox-group v-model="selectedColumns">
                <el-checkbox v-for="column in initializeColumns" :label="column" :key="column"></el-checkbox>
            </el-checkbox-group>
            <!--<span slot="reference">Colunas Visíveis<i class="el-icon-arrow-down el-icon--right"></i></span><span slot="reference">Colunas Visíveis<FSIcon name="filter"></FSIcon><i class="el-icon-arrow-down el-icon--right"></i></span><span slot="reference">Colunas Visíveis<FSIcon name="filter"></FSIcon><i class="el-icon-arrow-down el-icon--right"></i></span>-->
            <span slot="reference" class="icon-right"><FSIcon name="filter" width="30" height="30"></FSIcon></span>
        </el-popover>
        
        <el-badge :is-dot="true" :type="updateType" class="timeBadge"> 
            <el-dropdown placement="bottom-end" trigger="click" @command="importBases">
                <span class="el-dropdown-link">
                    <FSIcon name="clock" width="40" height="40"></FSIcon>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item style="display: flex" command="importPerformitFunds">
                        <el-badge class="timeBadge" :value="pRefDateStr" :type="pRefDateType" style="margin-left: 0;" />
                        <span style="margin-left: 8px; width: 60px; text-align: center">Performit</span>
                        <div style="position: relative; top: 5px; margin-left: 20px">
                            <FSIcon name="refresh-ccw" width="20" height="20"></FSIcon>
                        </div>
                    </el-dropdown-item>
                    <hr>
                    <el-dropdown-item style="display: flex" command="importQuantumDaily">
                        <el-badge class="timeBadge" :value="qLastUpdateStr" :type="qLastUpdateType" style="margin-left: 0;" />
                        <span style="margin-left: 8px; width: 60px; text-align: center">Bolsa</span>
                        <div style="position: relative; top: 5px; margin-left: 20px">
                            <!--<a :href="importQuantumDailyURL" target="_blank">-->
                                <FSIcon name="refresh-ccw" width="20" height="20"></FSIcon>
                            <!--</a>-->
                        </div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-badge>
    </el-row>
    <div style="height: 98%;">
        <el-table v-loading="loading" :data="tableData" stripe style="width: 1800px;" size="medium" height="98%"
        :default-sort="{prop: 'calculatedFields.fundWeight', order: 'descending'}"
        :cell-class-name="cellClass" header-row-class-name="tableHeader">
        
            <el-table-column label="Empresa" min-width="120" fixed>
                <template slot="header">
                    <el-row>
                        Empresa
                        <FSIcon name="external-link" width="15" style="margin-left: 5px"></FSIcon>
                    </el-row>
                </template>
                <template slot-scope="scope">
                    <el-popover placement="right" width="fit-content" trigger="click">
                        <el-row>
                            <a :href="scope.row.externalLinks.cvm" target="_blank">
                                <img src="logo_cvm.png" alt="CVM logo" class="popover-img">
                            </a>
                            <!--<a :href="scope.row.externalLinks.evernote" target="_blank">
                                <img src="logo_evernote.png" alt="Evernote logo" class="popover-img">
                            </a>-->
                            <a :href="scope.row.externalLinks.irWebsite" target="_blank">
                                <img src="logo_ri.png" alt="Investor Relations Website logo" class="popover-img">
                            </a>
                            <el-badge :value="scope.row.numberOfFiles" v-if="scope.row.numberOfFiles > 0" :max="10" type="primary">
                                <el-tooltip effect="dark" :content="tooltipFilesContent" placement="bottom-start">
                                    <span @click="showFiles(scope)"><img src="file-text.PNG" alt="One Pager" class="popover-img2"></span>
                                </el-tooltip>
                            </el-badge>
                            <!--<a :href="scope.row.externalLinks.onePager" v-if="scope.row.externalLinks.onePager" target="_blank">
                                <img src="file-text.PNG" alt="One Pager" class="popover-img2">
                            </a>-->
                            <a @click="editCompany(scope)" style="float: right">
                                <img src="edit.PNG" alt="Editar empresa" class="popover-img2">
                                <!--<FSIcon name="edit" width="60" height="60" style="margin-left: 5px"></FSIcon>-->
                            </a>
                        </el-row>
                        <img slot="reference"
                        :src="'companies-logos/logo_' + scope.row.myTicker.toLowerCase() + '.png'" 
                        :alt="scope.row.myTicker +  ' logo'"
                        class="logo-in-table">
                    </el-popover>
                </template>
            </el-table-column>
            
            <!-- <el-table-column prop="edit" label="" width="40">
                <template slot-scope="scope">
                    <span @click="editEmpresa(scope)"><FSIcon name="edit" width="15" style="margin-left: 5px"></FSIcon></span>
                </template>
            </el-table-column> -->
            
            <el-table-column prop="myTicker" label="Ticker" sortable sort-by="myTicker" min-width="100">
            </el-table-column>
            
            <el-table-column prop="mySector" v-if="isSetorVisible" label="Setor" :filters="sectorFilters" :filter-method="commonFilter" min-width="100">
            </el-table-column>
            
            <el-table-column prop="analyst" v-if="isAnalistaVisible" label="Analista" :filters="analystFilters" :filter-method="includesFilter" min-width="100">
            </el-table-column>

            <el-table-column label="Mktcap (R$, mn)" v-if="isMktcapVisible" prop="quantum.mktCap" sortable sort-by="quantum.mktCap" 
                :formatter="numberFormatter2" min-width="150">
            </el-table-column>
            
            <el-table-column label="EV (R$, mn)" v-if="isEVVisible" prop="quantum.ev" sortable sort-by="quantum.ev" 
                :formatter="numberFormatter2" min-width="120">
            </el-table-column>
            
            <el-table-column label="ADTV 30d (R$, mn)" v-if="isADTV30dVisible" prop="quantum.adtv30d" sortable sort-by="quantum.adtv30d"
                :formatter="numberFormatter1" min-width="170">
            </el-table-column>
            
            <el-table-column label="EV/EBITDA 12m" v-if="isEvEbitda12mVisible" prop="quantum.evEbitda12m" sortable sort-by="quantum.evEbitda12m" 
                :formatter="numberFormatter3" min-width="175">
                <!--<template slot="header" slot-scope="scope">-->
                <!--    <span>EV/<br>EBITDA 12m</span>-->
                <!--</template>-->
            </el-table-column>
            
            <el-table-column label="P/E 12m" v-if="isPE12mVisible" prop="quantum.pe12m" sortable sort-by="quantum.pe12m" 
                :formatter="numberFormatter3" min-width="110">
            </el-table-column>
            
            <el-table-column label="P/Book" v-if="isPBookVisible" prop="quantum.pb" sortable sort-by="quantum.pb" 
                :formatter="numberFormatter3" min-width="110">
            </el-table-column>
            
            <el-table-column label="Preço D-1 (R$)" v-if="isPrecoVisible" prop="quantum.lastClose" :formatter="numberFormatter4" min-width="110">
            </el-table-column>
            
            <el-table-column label="1D" v-if="is1DVisible" prop="quantum.perf1D" :formatter="numberFormatter5" 
                sortable sort-by="quantum.perf1D" min-width="70">
            </el-table-column>
            
            <el-table-column label="MTD" v-if="isMTDVisible" prop="quantum.perfMTD" :formatter="numberFormatter5" 
                sortable sort-by="quantum.perfMTD" min-width="85">
            </el-table-column>
            
            <el-table-column label="YTD" v-if="isYTDVisible" prop="quantum.perfYTD" :formatter="numberFormatter5" 
                sortable sort-by="quantum.perfYTD" min-width="85">
            </el-table-column>
            
            <el-table-column label="12M" v-if="is12MVisible" prop="quantum.perf12M" :formatter="numberFormatter5" 
                sortable sort-by="quantum.perf12M" min-width="85">
            </el-table-column>
            
            <!--<el-table-column label="Vol. 30d" prop="quantum.vol30D" :formatter="numberFormatter5" -->
            <!--    sortable sort-by="quantum.vol30D" width="90">-->
            <!--</el-table-column>-->
            
            <!--<el-table-column prop="calculatedFields.totalShares" :formatter="numberFormatter6" width="120" >-->
            <!--    <template slot="header" slot-scope="scope">-->
            <!--        <span>LEQ<br># Ações</span>-->
            <!--    </template>-->
            <!--</el-table-column>-->
            
            <el-table-column label="% Empresa" v-if="isPercEmpresaVisible" prop="calculatedFields.companyOwnership" :formatter="numberFormatter5" 
                sortable sort-by="calculatedFields.companyOwnership" min-width="130">
            </el-table-column>
            
            <el-table-column label="Days of Trading" v-if="isDaysOfTradingVisible" prop="calculatedFields.daysOfTrading" :formatter="numberFormatter3" 
                sortable sort-by="calculatedFields.daysOfTrading" min-width="160">
            </el-table-column>
            
            <!--<el-table-column prop="calculatedFields.totalBRL" :formatter="numberFormatter1" -->
            <!--    sortable sort-by="calculatedFields.totalBRL" width="90">-->
            <!--    <template slot="header" slot-scope="scope">-->
            <!--        <span>LEQ<br>Total R$</span>-->
            <!--    </template>-->
            <!--</el-table-column>-->
            
            <el-table-column label="% Fundo" v-if="isPercFundoVisible" prop="calculatedFields.fundWeight" :filters="fundWeightFilters" :filter-method="fundWeightFilterMethod" :formatter="numberFormatter5" 
                sortable sort-by="calculatedFields.fundWeight" min-width="120">
            </el-table-column>

            <el-table-column prop="quantum._lastUpdate" v-if="isLastUpdateQuantumVisible" label="Última atualização Bolsa" 
                sortable sort-by="quantum._lastUpdate" min-width="200">
            </el-table-column>

            <el-table-column prop="performit._lastUpdate" v-if="isLastUpdatePerformitVisible" label="Última atualização Performit" 
                sortable sort-by="performit._lastUpdate" min-width="230">
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import fb from '@/services/firebaseConfig'
import formatters from '@/services/formatters'
import CadastroEmpresasForm from '@/components/CadastroEmpresasForm'
import FilesDialog from '@/components/FilesDialog'
import validator from '@/services/validators'
import firebase from 'firebase/app'

const db = fb.db
const app = fb.app

export default {
    data() {
        return {
            tableData: [],
            pRefDate: null,
            qLastUpdate: null,
            loading: null,
            formCadastroVisible: false,
            filesDialogVisible: false,
            setorVisible: false,
            company: {},
            urls: [],
            selectedColumns: ["Mktcap", "Setor", "Analista", "EV", "Preço D-1", "1D", "MTD", "YTD", "12M", "Days of Trading", "% Fundo"],
            columns: [],
            checkAll: false,
            tooltipFilesContent: "OnePager, DCF Economática e outros arquivos."
        }
    },
    components: {
        CadastroEmpresasForm,
        FilesDialog
    },
    computed: {
        sectorFilters() {
            return this.filterFunction('mySector')
        },
        fundWeightFilters() {
            return this.fundWeightFilterFunction()
        },
        analystFilters() {
            return this.filterFunction('analyst')
        },
        pRefDateStr() {
            return this.pRefDate != null ?
                formatters.timestampFormatter(this.pRefDate) :
                '#n/a'
        },
        qLastUpdateStr() {
            return this.qLastUpdate != null ?
                formatters.timestampFormatter(this.qLastUpdate) :
                '#n/a'
        },
        lastWeek() {
            let lastWeek = new Date()
            lastWeek.setDate(lastWeek.getDate() - 7)
            return lastWeek
        },
        pRefDateType() {
            if (this.pRefDate != null) {
                // let d = new Date(formatters.timestampFormatter(this.pRefDate))
                let d = formatters.timestampFormatter(this.pRefDate)
                return d <= this.lastWeek ? 'danger' : 'success'
            }
            else {
                return 'danger'
            }
        },
        qLastUpdateType() {
            if (this.qLastUpdate != null) {
                // let d = new Date(formatters.timestampFormatter(this.qLastUpdate))
                let d = formatters.timestampFormatter(this.qLastUpdate)
                return d <= this.lastWeek ? 'danger' : 'success'
            } else {
                return 'danger'
            }
        },
        updateType() {
            return this.pRefDateType == 'danger' || this.qLastUpdateStr == 'danger' ?
                'danger' :
                'success'
        },
        initializeColumns() {
            this.columns = [
                "Setor",
                "Analista",
                "Mktcap",
                "EV",
                "ADTV 30d",
                "EV/EBITDA 12m",
                "P/E 12m",
                "P/Book",
                "Preço D-1",
                "1D",
                "MTD",
                "YTD",
                "12M",
                "% Empresa",
                "Days of Trading",
                "% Fundo",
                "Última atualização Bolsa",
                "Última atualização Performit"
            ]
            return this.columns
        },
        isSetorVisible() {
            return this.isColumnVisible('Setor')
        },
        isAnalistaVisible() {
            return this.isColumnVisible('Analista')
        },
        isLastUpdateQuantumVisible() {
            return this.isColumnVisible('Última atualização Bolsa')
        },
        isLastUpdatePerformitVisible() {
            return this.isColumnVisible('Última atualização Performit')
        },
        isMktcapVisible() {
            return this.isColumnVisible('Mktcap')
        },
        isEVVisible() {
            return this.isColumnVisible('EV')
        },
        isADTV30dVisible() {
            return this.isColumnVisible('ADTV 30d')
        },
        isEvEbitda12mVisible() {
            return this.isColumnVisible('EV/EBITDA 12m')
        },
        isPE12mVisible() {
            return this.isColumnVisible('P/E 12m')
        },
        isPBookVisible() {
            return this.isColumnVisible('P/Book')
        },
        isPrecoVisible() {
            return this.isColumnVisible('Preço D-1')
        },
        is1DVisible() {
            return this.isColumnVisible('1D')
        },
        isMTDVisible() {
            return this.isColumnVisible('MTD')
        },
        isYTDVisible() {
            return this.isColumnVisible('YTD')
        },
        is12MVisible() {
            return this.isColumnVisible('12M')
        },
        isPercEmpresaVisible() {
            return this.isColumnVisible('% Empresa')
        },
        isDaysOfTradingVisible() {
            return this.isColumnVisible('Days of Trading')
        },
        isPercFundoVisible() {
            return this.isColumnVisible('% Fundo')
        },
        importQuantumDailyURL() {
            return 'https://us-central1-'+ app.options.projectId +'.cloudfunctions.net/importQuantumDaily?manual=&test='
        },
    },
    methods: {
        isColumnVisible(columnName){
            return this.selectedColumns.includes(columnName)
        },
        isLinkFilled(str) {
            return !str || str.trim() === ''
        },
        async importBases(command) {
            
            if(!command) return
            
            console.log("chamando " + command)
            let importBases = firebase.functions().httpsCallable('callImportFromDashboard')
            try {
                let res = await importBases({function: command})
                console.log(res)
                this.$root.$emit('showError', "Importação realizada com sucesso", 'success')
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        numberFormatter1(row, column, cellValue) {
            return formatters.numberFormatter(
                cellValue,
                10 ** 6,
                'decimal',
                1,
                '',
                ''
            )
        },
        numberFormatter2(row, column, cellValue) {
            return formatters.numberFormatter(
                cellValue,
                10 ** 3,
                'decimal',
                0,
                '',
                ''
            )
        },
        numberFormatter3(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'decimal', 1)
        },
        numberFormatter4(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'decimal', 2)
        },
        numberFormatter5(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'percent', 2)
        },
        numberFormatter6(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'decimal', 0)
        },
        dateFormatter1(row, column, cellValue) {
            return formatters.timestampFormatter(cellValue)
        },
        commonFilter(value, row, column) {
            const property = column['property']
            return row[property] === value
        },
        includesFilter(value, row, column) {
            const property = column['property']
            return row[property].includes(value)
        },
        fundWeightFilterMethod(value, row, column) {
            if(value === 0) return row.calculatedFields.fundWeight === 0
            return row.calculatedFields.fundWeight > 0
        },
        fundWeightFilterFunction() {
            let filters = [{text: 'Investido', value: 1}, {text: 'Não Investido', value: 0}]
            return filters
        },
        filterFunction(prop, blank = ['', '-']) {
            let list = []
            let filters = []
            this.tableData.forEach(row => {
                list.push(row[prop])
            })
            list = [...new Set(list)].sort()
            list.forEach(each => {
                filters.push({ text: each === blank[0] ? blank[1] : each, value: each })
            })
            return filters
        },
        cellClass(obj) {
            let props = [
                'quantum.perf1D',
                'quantum.perfMTD',
                'quantum.perfYTD',
                'quantum.perf12M'
            ]
            let prop = obj.column.property
            if (props.indexOf(prop) != -1) {
                let value = obj.row.quantum[prop.replace('quantum.', '')]
                return value >= 0 ? 'posPerf' : 'negPerf'
            }
        },
        closeCadastroDialog() {
            this.formCadastroVisible = false
        },
        openCadastroForm() {
            this.formCadastroVisible = true
        },
        closeFilesDialog() {
            this.filesDialogVisible = false
        },
        openFilesDialog() {
            this.filesDialogVisible = true
        },
        showFiles(scope) {
            this.urls = scope.row.externalLinks.files || []
            this.openFilesDialog()
        },
        editCompany(scope) {
            
            this.company = {
                myTicker: scope.row.myTicker,
                analyst: scope.row.analyst.split(','),
                cnpj: scope.row.cnpj,
                codCVM: scope.row.codCVM,
                externalLinks: {
                    irWebsite: scope.row.externalLinks.irWebsite,
                    files: scope.row.externalLinks.files || []
                },
                mySector: scope.row.mySector,
                performit: {
                    symbols: scope.row.performit.symbols
                },
                quantum: {
                    quantumNames: {
                        acao: scope.row.quantum.quantumNames.acao,
                        empresa: scope.row.quantum.quantumNames.empresa
                    }
                },
                newCompany: false,
                id: scope.row.id,
            }
            this.openCadastroForm()
        },
        addCompany() {
            this.company = {
                myTicker: "",
                analyst: [],
                cnpj: "",
                codCVM: "",
                externalLinks: {
                    irWebsite: "",
                    files: []
                },
                mySector: "",
                performit: {
                    symbols: []
                },
                quantum: {
                    quantumNames: {
                        acao: "",
                        empresa: ""
                    }
                },
                newCompany: true,
                id: ""
            }
            this.openCadastroForm()
        },
        showAllColumns(val) {
            // this.loading = true
            this.selectedColumns = val ? this.initializeColumns : ["Mktcap", "Setor", "Analista", "EV", "Preço D-1", "1D", "MTD", "YTD", "12M", "Days of Trading", "% Fundo"]
            // this.loading = false
        },
    },
    created() {
        this.loading = true
        db.collection('coveredCompanies')
            .orderBy('calculatedFields.fundWeight', 'desc')
            .onSnapshot(
                qSnapshot => {
                    let list = []
                    qSnapshot.forEach(doc => {
                        let obj = doc.data()
                        obj.analyst = Array.isArray(obj.analyst) ? obj.analyst.sort().join(',') : obj.analyst
                        if (obj.quantum && obj.quantum._lastUpdate) {
                            let date = obj.quantum._lastUpdate.toDate()
                            obj.quantum._lastUpdate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}
                                 ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
                        }
                        if (obj.performit && obj.performit._lastUpdate) {
                            let date = obj.performit._lastUpdate.toDate()
                            obj.performit._lastUpdate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}
                                 ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
                        }
                        Object.assign(obj, {id: doc.id, numberOfFiles: (obj.externalLinks.files || []).length})
                        list.push(obj)
                        // list.push(doc.data())
                    })
                    this.tableData = list
                    this.loading = false
                },
                error => {
                    this.loading = false
                    console.log(error)
                    this.$notify.error({
                        title: 'Erro',
                        message: 'Não foi possível carregar as empresas da cobertura',
                        duration: 0
                    })
                }
            )
    
        db.collection('performitFunds')
            .orderBy('_lastUpdate', 'desc')
            .orderBy('_refDate', 'desc')
            .limit(1)
            .onSnapshot(
                qSnapshot => {
                    qSnapshot.forEach(doc => {
                        this.pRefDate = doc.data()._refDate
                    })
                },
                error => {
                    console.log(error)
                    this.$notify.error({
                        title: 'Erro',
                        message: 'Não foi possível carregar data de atualização do Performit',
                        duration: 0
                    })
                }
            )
            
        db.collection('quantumDaily')
            .orderBy('_lastUpdate', 'desc')
            .limit(1)
            .onSnapshot(
                qSnapshot => {
                    qSnapshot.forEach(doc => {
                        this.qLastUpdate = doc.data()._lastUpdate
                    })
                },
                error => {
                    console.log(error)
                    this.$notify.error({
                        title: 'Erro',
                        message: 'Não foi possível carregar data de atualização da Bolsa',
                        duration: 0
                    })
                }
            )
    },
}
</script>

<style scoped>
.view {
  height: 98.5%;
  width: fit-content;
  max-width: 100%;
}

.logo-in-table {
  vertical-align: middle;
  max-height: 100%;
  max-width: 100%;
}

.cell span {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  width: 100px;
  height: 45px;
}

.popover-img {
  max-width: 45px;
  max-height: 30px;
  vertical-align: middle;
  margin-right: 15px;
}

.popover-img2 {
  max-width: 45px;
  max-height: 40px;
  vertical-align: middle;
}

.timeBadge {
  float: left;
  margin-top: 4px;
  margin-left: 10px;
}

.icon-right {
    float: right;
    color: #606266;
    margin-top: 10px;
}

.button-cadastro {
  float: right;
  margin-left: 10px;
  margin-top: 6.5px;
}

.el-button--mini.is-circle {
    padding: 5px;
}

td {
  padding-top: 5px;
  padding-bottom: 5px;
}
.posPerf {
  color: #12b112;
  font-weight: bold;
}
.negPerf {
  color: red;
  font-weight: bold;
}
.tableHeader {
  font-size: 16px;
  font-weight: bold;
}
div >>> .el-table__body-wrapper {
    min-height: 765px;
}
div >>> .el-table__fixed-body-wrapper {
    top: 68px !important;
    height: inherit !important;
}

hr { 
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
} 
a:visited {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
}
</style>